import { combineReducers } from '@reduxjs/toolkit';

import { listSlice } from './listSlice';
import { registrationSlice } from './registrationSlice';
import { editSlice } from './editSlice';
import { customersSlice } from './customersSlice';

export const notificationReducer = combineReducers({
  /** お知らせ一覧の状態 */
  list: listSlice.reducer,
  /** お知らせ登録の状態 */
  registration: registrationSlice.reducer,
  /** お知らせ編集の状態 */
  edit: editSlice.reducer,
  /** 顧客一覧の状態（登録画面・編集画面で共用） */
  customers: customersSlice.reducer,
});
